import React from 'react'
import PropTypes from 'prop-types'

import { FlyingCube, Heading } from 'Components/Blocks/_Legacy'
import { Border, Motion, Wrapper } from 'Components/UI'

import { processGlyph } from 'Assets/_Legacy/BlockchainPage/icons'

import RoadMap from './RoadMap'
import { Container, Content } from './styles'

function Process({ data }) {
  return (
    <>
      <Border bg="almond" topRight />

      <Container>
        <FlyingCube
          desktopOnly
          left={-76}
          rotateAngle={39}
          size={277}
          top="50%"
        />

        <Wrapper wayPointTop>
          <Content>
            <Motion>
              <Heading
                horizontalAlign="center"
                maxWidth={700}
                mb={[5, 5, 17, 17, 19]}
                mx="auto"
                subTitleText={data?.processHeader?.subtitleText}
                tagGlyph={processGlyph}
                tagText={data?.processHeader?.overheadText}
                tagTextAs="h4"
                titleText={{
                  first: {
                    text: data?.processHeader?.titleTextFirst,
                    bold: data?.processHeader?.firstBold,
                  },
                  second: {
                    text: data?.processHeader?.titleTextSecond,
                    bold: data?.processHeader?.secondBold,
                  },
                  third: {
                    text: data?.processHeader?.titleTextThird,
                    bold: data?.processHeader?.thirdBold,
                  },
                }}
              />

              <RoadMap data={data?.processSteps} rendered />
            </Motion>
          </Content>
        </Wrapper>
      </Container>
    </>
  )
}

Process.defaultProps = {
  data: {},
}

Process.propTypes = {
  data: PropTypes.object,
}

export default Process
